import { LoadingButton, Stack } from "@altimateai/lego";
import { Badge, Card, CardContent, Typography } from "@altimateai/lego";
import { TeamMatesConfig } from "./teamMatesConfig";
import { TeamMateActionType, TeamMateAvailability } from "./types";
import { useMutation } from "../api/index";
import { Button } from "@altimateai/lego";

interface Props {
  config: (typeof TeamMatesConfig)[0];
  onSelect: (
    config: (typeof TeamMatesConfig)[0],
    action: TeamMateActionType
  ) => Promise<boolean | undefined>;
  client: keyof typeof TeamMateAvailability;
}
const TeamMatesCard = ({ config, client, onSelect }: Props) => {
  const handleRequestAccess = async () => {
    return await onSelect(config, TeamMateActionType.REQUEST_ACCESS);
  };
  const { loading, mutate, data } = useMutation({
    queryFn: handleRequestAccess,
  });
  const isComingSoon =
    typeof config.comingSoon === "function" ? config.comingSoon() : config.comingSoon;

  return (
    <Stack direction="column">
      <Card>
        <CardContent className="al-pt-4">
          <Stack justify="between" align="center" className="al-mb-2">
            <img alt="Teammate" src={config.avatar} className="al-w-16 al-h-16 al-rounded" />
            <div className="al-ml-2 al-mt-2">
              <Typography variant="subheading">{config.name}</Typography>
              <Typography>{config.description}</Typography>
            </div>
          </Stack>
          <Stack justify="between" align="center">
            <Stack justify="start" align="center">
              {isComingSoon ? (
                <>
                  <LoadingButton
                    size="sm"
                    className="al-cursor-pointer"
                    onClick={() => mutate()}
                    color="primary"
                    loading={loading}
                    disabled={!!data}
                  >
                    Request Access
                  </LoadingButton>
                  {data ? <p className="al-m-0">Our team will reach out soon</p> : null}
                </>
              ) : (
                <Button
                  size="sm"
                  className="al-cursor-pointer"
                  onClick={() => onSelect(config, TeamMateActionType.VIEW_DETAILS)}
                >
                  View details
                </Button>
              )}
              {config.seeInAction && config.availability.includes(TeamMateAvailability[client]) && (
                <Button
                  variant="outline"
                  size="sm"
                  className="al-cursor-pointer"
                  onClick={() => onSelect(config, TeamMateActionType.SEE_IN_ACTION)}
                >
                  See in action
                </Button>
              )}
            </Stack>
            {config.availability.map(availability => (
              <Badge variant="success" key={availability} className={availability}>
                {isComingSoon ? "Coming soon" : "Available"} in {availability}
              </Badge>
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default TeamMatesCard;
